import {ReservationDriverAssignOption} from "types/enums/specific/ReservationDriverAssignOption";
import React from "react";

import {useTranslation} from "react-i18next";
import FeatherIcon from "components/FeatherIcon";

export interface AssignReservationDriverOption {
    headerTitle?: string;
    label: string;
    subLabel?: string;
    value: ReservationDriverAssignOption;
    icon?: string | React.ReactNode;
    disabled?: boolean;
    isSelected?: boolean;
    isDisabled?: boolean;
    isNew?: boolean;
    isInvite?: boolean;
    isFamily?: boolean;
    isGuest?: boolean;
    isNewGuest?: boolean;
}

export const useReservationTicketOptions = () => {
    const {t} = useTranslation();

    const options = [ReservationDriverAssignOption.AssignFamily, ReservationDriverAssignOption.AssignGuest, ReservationDriverAssignOption.InviteGuest];

    const getOption = (option: ReservationDriverAssignOption): AssignReservationDriverOption => {
        switch (option) {
            case ReservationDriverAssignOption.AssignFamily:
                return {
                    label: t("Family and Friends"),
                    value: ReservationDriverAssignOption.AssignFamily,
                    icon: <FeatherIcon name={"users"} className={"size-[20px] md:size-[30px]"} strokeWidth={2} />,
                    isFamily: true,
                };
            case ReservationDriverAssignOption.AssignGuest:
                return {
                    label: t("Assign new guest"),
                    value: ReservationDriverAssignOption.AssignGuest,
                    icon: <FeatherIcon name={"user"} className={"size-[20px] md:size-[30px]"} strokeWidth={2} />,
                    isGuest: true,
                };

            case ReservationDriverAssignOption.InviteGuest:
            default:
                return {
                    label: t("Invite guest per e-mail"),
                    value: ReservationDriverAssignOption.InviteGuest,
                    icon: <FeatherIcon name={"user"} className={"size-[20px] md:size-[30px]"} strokeWidth={2} />,
                    isInvite: true,
                };
        }
    };

    const getOptions = options.map(option => getOption(option));

    return {
        options,
        getOption,
        getOptions,
    };
};
